
import { ViewHelpers_timeWindowDropdown, ViewHelpers_styledGroupedDropdown, ViewHelpers_styledDropdown, WeatherValue_valuesNotEmpty, ViewHelpers_mkText, ViewHelpers_mkTextSizeUnit, ViewHelpers_divWith, ViewHelpers_mkColumn, State__get_UnitText, ViewHelpers_spanWith, ViewHelpers_mkRowWith, ViewHelpers_spaceN, ViewHelpers_mkColumnWith, ViewHelpers_mkTextMulti, ViewHelpers_mkRow } from "./PortWindCommon.js";
import { Color, theme } from "../../Theme.js";
import { forAll, collect, append as append_1, isEmpty, sortBy, reverse, filter, map as map_1, empty, ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";
import { bind, toArray, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { stringHash, createObj, comparePrimitives, equals } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { formatNumber } from "../Common.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { IconModule_View } from "../../Components/StenaWebUI/Icons/Icon.js";
import { FSharpMap__TryFind, ofList } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { clearAllButton, Style_lastUpdatedBackground, Style_mapBoxInner } from "./PortWindDashboardHelpers.js";
import { Fragment, createElement } from "react";
import * as react from "react";
import { TileLayer } from "react-leaflet";
import { mapMarker } from "../../images/map-marker.svg.js";
import server from "react-dom/server";
import { DivIcon } from "leaflet";
import { Marker_View } from "../../Components/Leaflet/Marker.js";
import { MapContainer_View } from "../../Components/Leaflet/Container.js";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { trendCharts } from "./PortWindChart.js";
import { ship_at_quay as ship_at_quay_1 } from "../../images/ship_at_quay.svg.js";
import { SvgHelper_createSvgElement } from "../../fable_modules/Feliz.3.3.3/Svg.fs.js";
import { svg_height, svg_width } from "../../Feliz.js";
import { SpaceModule_View } from "../../Components/StenaWebUI/Core/Space.js";
import { DateTimeOffset_dateTimeWithTimezone, DateTimeOffset_dateTimeStr } from "../../Components/TimeZones/Components.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { SensorCategory__ToString, SensorId, SensorId__get_Value } from "../../StenaWeather.Domain/PortWind.js";
import { Msg } from "./PortWindDashboardState.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0/Seq2.js";
import { addHours, utcNow, now as now_1, date } from "../../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { DateRange } from "../../Components/StenaWebUI/Calendar/DateRangeDualTextInput.js";
import { fromDateTimeOffset, addYears, toString } from "../../fable_modules/fable-library-js.5.0.0/Date.js";
import { DateRangeDualTextInputModule_View } from "../../Components/StenaWebUI/Calendar/DateRangeDualTextInput.js";
import { SwitchModule_View } from "../../Components/StenaWebUI/Forms/Switch.js";
import { contains } from "../../fable_modules/fable-library-js.5.0.0/Set.js";
import { CheckboxWithLabelModule_View } from "../../Components/StenaWebUI/Elements/CheckBox.js";

function WeatherBox_labelRow(labels) {
    return ViewHelpers_mkRow(singleton(ViewHelpers_mkTextMulti(1 + "vmin", theme(new Color(4, [])), labels)));
}

function WeatherBox_mkContent$0027(props, labels, extraRowItem, rowItem) {
    const x_1 = ViewHelpers_mkColumnWith([["alignItems", "center"], ["width", "100%"], ["height", "100%"]], toList(delay(() => append(ViewHelpers_spaceN(2), delay(() => append(singleton_1(WeatherBox_labelRow(labels)), delay(() => {
        let x;
        return append(singleton_1(ViewHelpers_mkRowWith([["height", "100%"]], singleton(ViewHelpers_mkColumnWith([["height", "100%"], ["alignItems", "center"], ["justifyContent", "center"]], singleton((x = rowItem, defaultArg(map((e) => ViewHelpers_spanWith([], ofArray([e, x])), extraRowItem), x))))))), delay(() => ViewHelpers_spaceN(2)));
    })))))));
    if (equals(props, empty())) {
        return x_1;
    }
    else {
        return ViewHelpers_spanWith(props, singleton(x_1));
    }
}

export function WeatherBox_content(props, label, rowItem) {
    return WeatherBox_mkContent$0027(props, singleton([label, 4]), undefined, rowItem);
}

export function WeatherBox_contentSublabel(props, label, sublabel, extraItem, rowItem) {
    return WeatherBox_mkContent$0027(props, ofArray([[label, 4], [sublabel, 2]]), extraItem, rowItem);
}

export function WeatherBox_weatherValue(state, d, weatherPoint, iconProps) {
    const matchValue = d.GetValue(state, weatherPoint);
    if (matchValue != null) {
        const value = matchValue;
        let patternInput;
        const matchValue_1 = d.Unit;
        patternInput = ((matchValue_1.tag === 2) ? [(x_1) => formatNumber(d.ValueFormat, x_1), "m"] : ((matchValue_1.tag === 1) ? [(x_2) => concat(formatNumber(d.ValueFormat, x_2), ..."°"), ""] : [(x) => formatNumber(d.ValueFormat, x), State__get_UnitText(state)]));
        return ViewHelpers_mkRow(ofArray([ViewHelpers_mkColumn(singleton(ViewHelpers_divWith(iconProps(value), singleton(IconModule_View(ofList(map_1((value_2) => value_2, ofArray([["icon", d.Icon], ["color", theme(new Color(4, []))], ["size", 12 + "vmin"]])), {
            Compare: (x_3, y) => (comparePrimitives(x_3, y) | 0),
        })))))), ViewHelpers_mkColumnWith([["justifyContent", "center"]], singleton(ViewHelpers_spanWith([], ofArray([ViewHelpers_mkTextSizeUnit(theme(new Color(4, [])), 6 + "vmax", [["fontWeight", "bold"]], patternInput[0](value)), ViewHelpers_mkText(theme(new Color(4, [])), 3, [["marginLeft", 0.4 + "vw"]], " " + patternInput[1])]))))]));
    }
    else {
        return ViewHelpers_mkRow(empty());
    }
}

export function WeatherBox_mapBox(columnWidth, rowHeight, mapKey, location, zoom) {
    return ViewHelpers_mkColumn(singleton(ViewHelpers_divWith([["style", createObj(Style_mapBoxInner(columnWidth, rowHeight))]], toList(delay(() => {
        let p_1_3, props, p_1_2, props_1, arg, arg_1, arg_2, arg_3, arg_4;
        return singleton_1(createElement(Fragment, {
            key: mapKey,
        }, (p_1_3 = ofList(map_1((value_8) => value_8, ofArray([["center", location], ["zoom", zoom], ["children", ofArray([(props = {
            attribution: "&copy; <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        }, react.createElement(TileLayer, props)), (p_1_2 = ofList(map_1((value_7) => value_7, ofArray([["position", location], ["icon", (props_1 = ofArray([["html", mapMarker], ["iconSize", [24, 24]], ["iconAnchor", [12, 12]]]), (arg = defaultArg(map((element) => server.renderToString(element), map((x_1) => x_1, FSharpMap__TryFind(ofList(map_1((value_1) => value_1, props_1), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }), "html"))), ""), (arg_1 = map((x_3) => x_3, FSharpMap__TryFind(ofList(map_1((value_3) => value_3, props_1), {
            Compare: (x_2, y_1) => (comparePrimitives(x_2, y_1) | 0),
        }), "iconSize")), (arg_2 = map((x_5) => x_5, FSharpMap__TryFind(ofList(map_1((value_4) => value_4, props_1), {
            Compare: (x_4, y_2) => (comparePrimitives(x_4, y_2) | 0),
        }), "iconAnchor")), (arg_3 = map((x_7) => x_7, FSharpMap__TryFind(ofList(map_1((value_5) => value_5, props_1), {
            Compare: (x_6, y_3) => (comparePrimitives(x_6, y_3) | 0),
        }), "popupAnchor")), (arg_4 = map((x_9) => x_9, FSharpMap__TryFind(ofList(map_1((value_6) => value_6, props_1), {
            Compare: (x_8, y_4) => (comparePrimitives(x_8, y_4) | 0),
        }), "className")), new DivIcon({html: arg, iconSize: arg_1, iconAnchor: arg_2, popupAnchor: arg_3, className: arg_4})))))))]])), {
            Compare: (x_10, y_5) => (comparePrimitives(x_10, y_5) | 0),
        }), createElement(Marker_View, {
            p: p_1_2,
        }))])]])), {
            Compare: (x_11, y_6) => (comparePrimitives(x_11, y_6) | 0),
        }), createElement(MapContainer_View, {
            p: p_1_3,
        }))));
    })))));
}

export function WeatherBox_mapBoxMaximizeIcon(onClick) {
    let t;
    return ViewHelpers_spanWith([["className", "box-corner-icon"], ["onClick", (_arg) => {
        onClick();
    }]], singleton(IconModule_View(ofList(map_1((value_4) => value_4, ofArray([(t = faExpand, ["icon", t]), ["color", theme(new Color(4, []))], ["size", 4 + "vmin"]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }))));
}

export function WeatherBox_trendChart(columnWidth, rowHeight, viewPort, tzCtx, state, trendChartValuesFilter) {
    const aspect = (columnWidth * viewPort.Width) / ((rowHeight - 12) * viewPort.Height);
    return ViewHelpers_divWith([["style", {
        width: columnWidth + "vw",
    }]], singleton(createElement(trendCharts, {
        ctx: tzCtx,
        viewPort: viewPort,
        smallAspect: aspect,
        multipleChartsValues: singleton(filter(trendChartValuesFilter, WeatherValue_valuesNotEmpty(state))),
        state: state,
    })));
}

export function WeatherBox_rotatingDirectionSvg(columnWidth, rowHeight, v) {
    const mergeTransforms = (xs) => ["transform", join(" ", reverse(map_1((x) => x[1], xs)))];
    const ship_at_quay = ship_at_quay_1(theme(new Color(4, [])), v.Flip, false);
    return ViewHelpers_divWith([["style", {
        display: "block",
        margin: "auto",
    }]], singleton(SvgHelper_createSvgElement("svg", ofArray([["viewBox", `${0} ${0} ${~~ship_at_quay.Width} ${~~ship_at_quay.Height}`], svg_width(columnWidth + "vw"), svg_height(rowHeight + "vh"), ["children", singleton(SvgHelper_createSvgElement("g", ofArray([mergeTransforms(v.WholeSvgTransform), ["children", ofArray([SvgHelper_createSvgElement("g", ofArray([mergeTransforms(v.SvgTransform), ["children", singleton(v.Svg)]])), SvgHelper_createSvgElement("g", singleton(["children", singleton(v.SvgArrow)]))])]])))]]))));
}

export function Header_lastUpdatedView(isStale, sensor, lastUpdated) {
    const txt = (str) => ViewHelpers_mkText(theme(new Color(0, [])), 2, [], str);
    const txtBold = (str_1) => ViewHelpers_mkText(theme(new Color(0, [])), 2, [["fontWeight", "bold"]], str_1);
    return ViewHelpers_mkColumn(toList(delay(() => {
        let p_1_1;
        return append(singleton_1(ViewHelpers_divWith([["style", createObj(Style_lastUpdatedBackground(isStale))]], singleton(ViewHelpers_mkRow(ofArray([txtBold("Last updated: "), (p_1_1 = ofList(map_1((value_2) => value_2, empty()), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }), createElement(SpaceModule_View, {
            p: p_1_1,
        })), txt(DateTimeOffset_dateTimeStr(DateTimeOffset_dateTimeWithTimezone(lastUpdated)))]))))), delay(() => ofArray(toArray(map((x_1) => {
            let p_1_2;
            return ViewHelpers_mkRowWith([["justifyContent", "flex-end"]], ofArray([txtBold("Source: "), (p_1_2 = ofList(map_1((value_3) => value_3, empty()), {
                Compare: (x_2, y_1) => (comparePrimitives(x_2, y_1) | 0),
            }), createElement(SpaceModule_View, {
                p: p_1_2,
            })), defaultArg(map((link) => HtmlHelper_createElement("a", ofArray([["href", link], ["children", [txt(x_1.Name)]]])), x_1.Link), txt(x_1.Name))]));
        }, bind((_arg) => _arg.Source, sensor))))));
    })));
}

export function Header_sensorSelectionDropdown(sensors, selectedSensor, dispatch) {
    const toOption = (s) => [s.Name, SensorId__get_Value(s.SensorId)];
    const selectedValue = map((_arg) => _arg.fields[0], selectedSensor);
    const onChange = (ev) => {
        dispatch(new Msg(2, [new SensorId(ev)]));
    };
    const sensors_1 = sortBy((_arg_1) => _arg_1.Name, sensors, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const groupSensors = filter((s_2) => !equals(s_2.GroupChildrens, empty()), sensors_1);
    if (isEmpty(groupSensors)) {
        return ViewHelpers_styledDropdown("Choose port to see wind statistics", map_1(toOption, sensors_1), selectedValue, onChange);
    }
    else {
        return ViewHelpers_styledGroupedDropdown("Choose port to see wind statistics", map_1((tupledArg) => [tupledArg[0], map_1(toOption, tupledArg[1])], append_1(List_groupBy((_arg_2) => SensorCategory__ToString(_arg_2.Category), filter((s_3) => equals(s_3.GroupChildrens, empty()), sensors_1), {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: (x_1) => (stringHash(x_1) | 0),
        }), singleton(["Groups", groupSensors]))), selectedValue, onChange);
    }
}

export function Header_dateRangePicker(dateTimeRange, dispatch) {
    let p_1_1;
    const nowDate = date(now_1());
    return ViewHelpers_spanWith([["style", {
        alignSelf: "center",
    }]], singleton((p_1_1 = ofList(map_1((value_2) => value_2, toList(delay(() => append(singleton_1(["value", new DateRange(map(date, dateTimeRange.fields[0]), map(date, dateTimeRange.fields[1]))]), delay(() => append(singleton_1(["onValueChange", (v) => {
        dispatch(new Msg(3, [v]));
    }]), delay(() => append(singleton_1(["minDate", toString(addYears(nowDate, -5), "yyyy-MM-dd")]), delay(() => singleton_1(["maxDate", toString(nowDate, "yyyy-MM-dd")])))))))))), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), createElement(DateRangeDualTextInputModule_View, {
        p: p_1_1,
    }))));
}

export function Header_trendTimeWindowDropdown(dispatch) {
    return ViewHelpers_timeWindowDropdown(ofArray([0.5, 1, 2, 3, 4, 6, 12, 24]), 4, (hours) => {
        const now = utcNow();
        dispatch(new Msg(3, [new DateRange(fromDateTimeOffset(addHours(now, -hours), 0), fromDateTimeOffset(now, 0))]));
    });
}

export function Header_unitSelectionSwitch(isMetric, dispatch) {
    let p_1_1, p_1_2, p_1_3;
    return ViewHelpers_mkColumnWith([["justifyContent", "center"]], singleton(ViewHelpers_mkRow(ofArray([ViewHelpers_mkColumnWith([["justifyContent", "center"]], singleton(ViewHelpers_mkText(theme(new Color(0, [])), 2, [], "knots"))), (p_1_1 = ofList(map_1((value) => value, empty()), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), createElement(SpaceModule_View, {
        p: p_1_1,
    })), (p_1_2 = ofList(map_1((value_1) => value_1, ofArray([["value", isMetric], ["onValueChange", (arg) => {
        dispatch(new Msg(6, [arg]));
    }]])), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), createElement(SwitchModule_View, {
        p: p_1_2,
    })), (p_1_3 = ofList(map_1((value_2) => value_2, empty()), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }), createElement(SpaceModule_View, {
        p: p_1_3,
    })), ViewHelpers_mkColumnWith([["justifyContent", "center"]], singleton(ViewHelpers_mkText(theme(new Color(0, [])), 2, [], "m/s")))]))));
}

/**
 * Returns the (visible, group-expanded) chart values and the checkbox row used to toggle their visibility.
 */
export function CheckboxControls_chartsValuesAndCheckboxes(dispatch, valuesNotEmpty, hiddenWeatherValues, expandForGroupSensor) {
    return [expandForGroupSensor(filter((x) => !contains(x.Id, hiddenWeatherValues), valuesNotEmpty)), collect((d) => {
        let p_1_1, p_1_2;
        return ofArray([(p_1_1 = ofList(map_1((value) => value, ofArray([["label", d.ChartName], ["value", !contains(d.Id, hiddenWeatherValues)], ["onValueChange", (isVisible) => {
            dispatch(new Msg(10, [d.Id, isVisible]));
        }]])), {
            Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
        }), createElement(CheckboxWithLabelModule_View, {
            p: p_1_1,
        })), (p_1_2 = ofList(map_1((value_1) => value_1, empty()), {
            Compare: (x_2, y_1) => (comparePrimitives(x_2, y_1) | 0),
        }), createElement(SpaceModule_View, {
            p: p_1_2,
        }))]);
    }, valuesNotEmpty)];
}

/**
 * Per-child-sensor visibility checkboxes for a group sensor (empty for a non-group sensor).
 */
export function CheckboxControls_sensorCheckboxes(dispatch, sensor, hiddenSensors, getSensorName) {
    let matchResult, s_1;
    if (sensor != null) {
        if (!equals(sensor.GroupChildrens, empty())) {
            matchResult = 0;
            s_1 = sensor;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const checkboxes = collect((childId) => {
                let p_1_1, p_1_2;
                return ofArray([(p_1_1 = ofList(map_1((value) => value, ofArray([["label", getSensorName(childId)], ["value", !contains(childId, hiddenSensors)], ["onValueChange", (isVisible) => {
                    dispatch(new Msg(13, [childId, isVisible]));
                }]])), {
                    Compare: (x, y) => (comparePrimitives(x, y) | 0),
                }), createElement(CheckboxWithLabelModule_View, {
                    p: p_1_1,
                })), (p_1_2 = ofList(map_1((value_1) => value_1, empty()), {
                    Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                }), createElement(SpaceModule_View, {
                    p: p_1_2,
                }))]);
            }, s_1.GroupChildrens);
            return append_1(singleton(ViewHelpers_mkRow(ofArray([clearAllButton(dispatch, forAll((id) => contains(id, hiddenSensors), s_1.GroupChildrens), new Msg(15, []), new Msg(14, [])), ViewHelpers_mkRow(checkboxes)]))), ViewHelpers_spaceN(2));
        }
        default:
            return empty();
    }
}

